import {en_US, es_ES, ja_JP, pt_PT, ru_RU, zh_CN, zh_TW} from 'ng-zorro-antd';

const globalConst = {
  System_Config: {
    Title: '微官网',
    // favicon: 'https://ptteng-hangzhou.oss-cn-hangzhou.aliyuncs.com/common/73923110-b2a6-4dc9-a335-1e432a106263.ico',
    favicon: '',
  },
  Tip: {
    Save_Success_Tip: '保存成功',
    Release_Success_Tip: '发布成功',
    Operation_Success: '操作成功',
    register_Success: '注册成功',
    Update_Success: '修改成功',
    Login_Success: 'tip.loginSuccessful', // 登录成功
    exitSuccessful: 'tip.exitSuccessful', // 退出成功
    Payment_Success: '支付成功',

    No_Keyword: '请输入关键字',

    Payment_Error: '支付失败',
    Payment_Overtime: '支付超时',
    Save_Error_Tip: '保存失败',
    Release_Error_Tip: '发布失败',
    Common_Error_Tip: '服务器发生错误',
    refundSuccess: 'tip.refundSuccess', // 退款成功
    rechargedSuccessfully: 'tip.rechargedSuccessfully', // 充值成功
    successfullyApplied: 'tip.successfullyApplied', // 申请成功
    submittedSuccessfully: 'tip.submittedSuccessfully', // 提交成功
    failedToGeneratePaymentQRCode: 'tip.failedToGeneratePaymentQRCode', //生成支付二维码失败
    paymentSuccessful: 'tip.paymentSuccessful',
    paymentFailed: 'tip.paymentFailed',
    successfullySaved: 'tip.successfullySaved',
    youHaveAlreadyPaidForThisOrder: 'tip.youHaveAlreadyPaidForThisOrder', //您已经支付过该笔订单
    pleaseSelectPaymentMethod: 'tip.pleaseSelectPaymentMethod', //请选择支付方式
    pleaseEnterTheRechargeAmount: 'placeholder.pleaseEnterTheRechargeAmount', //请输入充值金额
    pleaseCompleteTheInformation: 'tip.pleaseCompleteTheInformation', //请完善信息
    pleaseFillInYourPhoneNumber: 'tip.pleaseFillInYourPhoneNumber', //请填写手机号
    pleaseFillInTheEmailAddress: 'tip.pleaseFillInTheEmailAddress', //请填写邮箱
    pleaseFillInTheInvoiceHeader: 'tip.pleaseFillInTheInvoiceHeader', //请填写发票抬头
    TheMessageWasNotFound: 'tip.TheMessageWasNotFound', //未找到该条信息
    DockingIsInProgress: 'tip.dockingIsInProgress',//正在对接中，后期开放

  },
  File_Format: {
    unlimited: {value: null, label: '', size: 400},
    image: {value: 'image/png,image/jpeg,image/jpg', label: '上传图片格式建议png、jpeg、jpg', size: 20},
    image_svg: {value: 'image/png,image/jpeg,image/jpg,image/gif,image/svg+xml', label: '上传图片格式建议png、jpeg、jpg、gif、svg', size: 20},
    image_gif: {value: 'image/png,image/jpeg,image/jpg,image/gif', label: '上传图片格式建议png、jpeg、jpg、gif', size: 20},
    mp4: {value: 'video/mp4', label: '上传视频格式建议mp4', size: 400},
    mp3: {value: 'audio/mpeg', label: '上传音频格式建议mp3', size: 400},
    mp4_mov: {value: 'video/mp4,video/quicktime,', label: '上传视频格式建议mp4、mov', size: 400},

    Excel: {value: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', label: 'Excel', size: 200},
    pdf: {value: 'application/pdf', label: 'PDF', size: 200},
    word: {value: 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document', label: 'Word', size: 200},
    pdf_word: {value: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document', label: 'PDF、Word', size: 200},
    pdf_image: {value: 'application/pdf,image/png,image/jpeg,image/jpg', label: 'PDF、png、jpeg、jpg', size: 200},
    pdf_word_image: {
      value: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png,image/jpeg,image/jpg',
      label: 'PDF、Word、png、jpeg、jpg',
      size: 200
    },
  },
  internationalization: [
    {label: '简体中文', value: 'zh_CN', langText: '中'},
    {label: 'English', value: 'en_US', langText: 'En'},
    {label: 'русский', value: 'ru_RU', langText: 'Ru'},
    {label: 'Português', value: 'pt_PT', langText: 'Pt'},
    {label: '日本語', value: 'ja_JP', langText: 'Jp'},
    {label: 'Español', value: 'es_ES', langText: 'Es'},
    {label: '繁体中文', value: 'zh_TW', langText: '繁'}
  ],
  // 后台配置映射标准语言简写
  internationalizationMapping: {
    Cn: 'zh_CN',
    En: 'en_US',
    Ru: 'ru_RU',
    Pt: 'pt_PT',
    Jp: 'ja_JP',
    Es: 'es_ES',
    Tc: 'zh_TW'
  },
  // 标准语言简写映射微官网语言简写
  internationalizationMappingRelation: {
    'zh_CN': {interior: '', ant: zh_CN, value: 'Cn'},
    'en_US': {interior: 'En', ant: en_US, value: 'En'},
    'ru_RU': {interior: 'Ru', ant: ru_RU, value: 'Ru'},
    'pt_PT': {interior: 'Pt', ant: pt_PT, value: 'Pt'},
    'ja_JP': {interior: 'Jp', ant: ja_JP, value: 'Jp'},
    'es_ES': {interior: 'Es', ant: es_ES, value: 'Es'},
    'zh_TW': {interior: 'Tc', ant: zh_TW, value: 'Tc'},
  },
  multiLanguage: [
    {label: '中文', value: ''},
    {label: '英文', value: 'En'},
    {label: '俄语', value: 'Ru'},
    {label: '葡萄牙语', value: 'Pt'},
    {label: '日文', value: 'Jp'},
    {label: '西班牙语', value: 'Es'},
    {label: '简体中文', value: 'Tc'},
  ],
  Language: {
    En: {
      next: 'next page',
      prev: 'previous page',
      total: 'total',
      items: 'items',
      detailButton: 'More',
      moreButton: 'See more',
      contactUs: 'Contact Us',
      top: 'Top',
      detail: 'Detail',
      sendSuccess: 'Sent successfully',
      sendError: 'Failed to send',
      large: 'Large',
      default: 'Default',
      small: 'Small',
      fontSize: 'Font size',
    },
    Ru: {
      next: 'следующая страница',
      prev: 'предыдущая страница',
      total: 'всего',
      items: 'предметы',
      detailButton: 'Больше',
      moreButton: 'Смотреть больше',
      contactUs: 'Связаться с нами',
      top: 'вершина',
      detail: 'деталь',
      sendSuccess: 'Отправлен успешно',
      sendError: 'Ошибка при отправке',
      large: 'Большой',
      default: 'По умолчанию',
      small: 'Маленький',
      fontSize: 'Размер шрифта',
    },
    Pt: {
      next: 'próxima página',
      prev: 'página anterior',
      total: 'total',
      items: 'itens',
      detailButton: 'Mais',
      moreButton: 'Ver mais',
      contactUs: 'Contate-Nos',
      top: 'Topo',
      detail: 'Detalhe',
      sendSuccess: 'Enviado com sucesso',
      sendError: 'Falha ao enviar',
      large: 'Grande',
      default: 'Padrão',
      small: 'Pequeno',
      fontSize: 'Tamanho da fonte',
    },
    Jp: {
      next: '次のページ',
      prev: '前のページ',
      total: '合計',
      items: 'アイテム',
      detailButton: '詳細',
      moreButton: 'もっと見る',
      contactUs: 'お問い合わせ',
      top: 'トップ',
      detail: '詳細',
      sendSuccess: '送信成功しました',
      sendError: '送信に失敗しました',
      large: '大きい',
      default: 'デフォルト',
      small: '小さい',
      fontSize: 'フォントサイズ',
    },
    Es: {
      next: 'siguiente página',
      prev: 'página anterior',
      total: 'total',
      items: 'artículos',
      detailButton: 'Más',
      moreButton: 'Ver más',
      contactUs: 'Contáctanos',
      top: 'Top',
      detail: 'Detalle',
      sendSuccess: 'Enviado con éxito',
      sendError: 'Fallo al enviar',
      large: 'Grande',
      default: 'Predeterminado',
      small: 'Pequeño',
      fontSize: 'Tamaño de fuente',
    },
  },
  Pay_Status: [
    {value: 0, label: '待支付'},
    {value: 1, label: '已支付'},
    {value: 2, label: '待审核'},
    {value: 3, label: '已退款'},
    {value: 4, label: '已驳回'},
    {value: 5, label: '待退款'},
    {value: 6, label: '已支付'},
    {value: 7, label: '已支付'},
    {value: 8, label: '已支付'},
  ],
  Reimburse_Status: [
    {value: 6, label: '已同步'},
    {value: 7, label: '已报销'},
    {value: 8, label: '未同步'},
  ],
  Invoice_Status: [
    {value: 0, label: '无'},
    {value: 1, label: '待开票'},
    {value: 2, label: '已开票'},
    {value: 3, label: '已驳回'},
  ],
  Invoice_Type: [
    {value: 1, label: '普通发票'},
    {value: 2, label: '专用发票'},
  ],
  Invoice_Receipt_Type: [
    {value: 1, label: '个人'},
    {value: 2, label: '企业'},
  ],
  Invoice_List_Status: [
    {value: 1, label: '待开票'},
    {value: 2, label: '已驳回'},
    {value: 3, label: '已开票'},
  ],
  Bill_Release_Status: [
    {value: 0, label: '未发布'},
    {value: 1, label: '已发布'},
    {value: 2, label: '已作废'},
  ],
  Pay_Way: [
    {value: 1, label: '微信'},
    {value: 2, label: '支付宝'},
    {value: 3, label: '校内资金'},
    {value: 4, label: '充值余额'},
    {value: 5, label: '欠费余额'},
  ],
  Message_Status: [
    {value: 0, label: 'modules.lease.message.unread'},
    {value: 1, label: 'modules.lease.message.checked'},
  ],
  Balance_Status: [
    {value: 1, label: '待退款'},
    {value: 2, label: '已驳回'},
    {value: 3, label: '已退款'},
    {value: 4, label: '退款中'},
  ],
  Order_Status: [
    {value: 2, label: 'modules.shop.order.status.pending'}, // 待付款
    {value: 3, label: 'modules.shop.order.status.canceled'}, // 已取消
    {value: 6, label: 'modules.shop.order.status.paid'}, // 已付款
    {value: 1, label: 'modules.shop.order.status.complete'}, // 已完成
  ]
};

export {globalConst};
